export default {
  TALKOVER: 'talkover',
  SILENCE: 'silence',
  HOLD: 'hold',
  PAUSE: 'pause',
  COMMENT: 'comment',
  TRANSCRIPTION_HIT: 'hit',
} as const
